import React, { useEffect, useState } from 'react'
import { GiTeapotLeaves } from 'react-icons/gi';
import { fetchAllDataAPI } from '../../utils/api';
import { FaMobileAlt } from 'react-icons/fa';
import withAuth from '../../utils/withAuth';
import { BASEEMPURLS } from '../../utils/BaseUrl';

const TodayLeave = () => {
    const [absence, setAbsence] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getAbsence();
    }, []);

    const getAbsence = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-today-leave-absence').then((res) => {
            if (res.data.status === 1) {
                setAbsence(res.data.tempabsence || []);
            } else {
                setAbsence([]);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    const renderSkeleton = () => {
        return Array(4).fill(0).map((_, index) => (
            <div className="upcomingbirthday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                <div className="upcomingbirthdayimgname d-flex">
                    <div className="upcomingbirthdayimg">
                        <div className="skeleton skeleton-avatar"></div>
                    </div>
                    <div className="ms-2 upcomingbirthdayname">
                        <div className="skeleton skeleton-text w-75 mb-2"></div>
                        <div className="skeleton skeleton-text w-50"></div>
                    </div>
                </div>
                <div className="upcomingbirthdaydate">
                    <div className="skeleton skeleton-text w-50"></div>
                </div>
            </div>
        ));
    }

    const renderNoDataFound = () => {
        return (
            <div className="text-center py-4">
                <p className="text-secondary mb-0">☕ No Absence Today!</p>
            </div>
        );
    }

    return (
        <div className="card radius-10 overflow-hidden w-100 leavetodaysection topsection">
            <div className="d-flex align-items-center upcomingtitle">
                <div>
                    <h5 className="mb-0 pl-2">Today's Absence</h5>
                </div>
                <div className="birthdayicons">
                    <GiTeapotLeaves />
                </div>
            </div>

            <div className="p-2 ps ps--active-y bodysection">
                {isLoading ? (
                    renderSkeleton()
                ) : (
                    absence.length > 0 ? (
                        absence.map((item, index) => (
                            <div className="upcomingbirthday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                                <div className="upcomingbirthdayimgname d-flex">
                                    <div className="upcomingbirthdayimg">
                                        <img src={BASEEMPURLS(item?.emp_foto)} className="rounded-circle" alt="employee" />
                                    </div>
                                    <div className="ms-2 upcomingbirthdayname">
                                        <h6 className="mb-1 font-14">{item?.emp_name}</h6>
                                        <p className="mb-0 font-5 text-secondary">{item?.emp_job_role}</p>
                                    </div>
                                </div>
                                <div className="upcomingbirthdaydate">
                                    <span><FaMobileAlt /> {item?.emp_mobile}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        renderNoDataFound()
                    )
                )}
            </div>

            {/* Skeleton CSS */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                }
                .skeleton-avatar {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
                .skeleton-text {
                    height: 12px;
                    margin-bottom: 8px;
                    border-radius: 4px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    )
}

export default withAuth(TodayLeave)
